import { logout } from "@/state/server";
import { Link } from "@tanstack/react-router";
import { useAppContext } from "../state/appContext";
import type { Usuario } from "@/state/types";
import { Spinner } from "./Spinner";
import { sitioConfig } from "@/sitio";

export function Header() {
  const status = useAppContext();
  const usuario = status.state.usuario;

  const carrito = (usuario?.id &&
    usuario?.carrito &&
    usuario?.pedidos[usuario?.carrito]) || {
    fotos: [],
  };
  var elegidas = carrito.fotos
    .map((x) => x.cantidad || 0)
    .reduce((a, b) => a + b, 0);

  // #header es flex con wrap: los items se acomodan solos y no hay que
  // mantener una grilla de columnas fijas que ademas no coincidia con la
  // cantidad de hijos (el carrito es condicional y emite dos).
  return (
    <div id="header">
      <Link to="/">
        <img
          className="link"
          style={{ width: "100%", height: "auto" }}
          src={sitioConfig.logo}
        />
      </Link>
      <Link to="/" style={{ position: "relative" }}>
        <span style={{ position: "fixed" }}>
          <Spinner />
        </span>
        <img className="link icono" src="/images/buscar.svg" />
      </Link>
      {elegidas > 0 && usuario.carrito ? (
        <Link
          to="/pedido"
          search={{ id: usuario.carrito }}
          style={{
            color: "#fff",
            position: "relative",
            textDecoration: "none",
          }}
        >
          CARRITO
          <span
            style={{
              position: "absolute",
              top: "-0.5em",
              right: "-0.75em",
              padding: "0 0.25em",
              color: "#fff",
              borderRadius: "100%",
              backgroundColor: "#f00",
              fontSize: "75%",
            }}
          >
            {elegidas}
          </span>
        </Link>
      ) : null}
      <Link to="/pedidos" style={{ position: "relative" }}>
        <img className="link icono" src="/images/pedidos.svg" />
      </Link>
      {usuario?.id ? (
        <span className="link" onClick={logout} style={{ color: "#fff" }}>
          {usuario.nombre}
          {sitioConfig.local && <BuenCliente cliente={usuario} />}
        </span>
      ) : (
        <Link to="/login">
          <img className="link icono" src="/images/login.svg" />
        </Link>
      )}
    </div>
  );
}

export function Footer() {
  return (
    <div className="footer">
      Powered by <a href="http://www.fotronica.com/">Fotrónica</a> ©{" "}
      {new Date().getFullYear()}
      <Link to="/admin">.</Link>
    </div>
  );
}

function BuenCliente({ cliente }: { cliente: Usuario }) {
  const P = Object.values(cliente.pedidos).filter((p) => p.pagado).length;
  const F = Object.keys(cliente.compradas || {}).length;

  return (
    P > 0 && (
      <span style={{ position: "relative" }}>
        <span
          style={{
            fontSize: 10,
            position: "absolute",
            top: 0,
            left: 10,
            width: 100,
            textAlign: "left",
          }}
        >
          ({P}, {F})
        </span>
      </span>
    )
  );

  return P > 0 ? `` : "";
}
